import React from "react";
import DOMPurify from "dompurify";

export default class extends React.Component {


    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        
        const {field, formData} = this.props;
        formData[field.name] = formData[field.name] || !!field.default;
        this.state = { checked: false };
    }

    handleChange(event) {
        const {field, config, formData} = this.props;
        formData[field.name] = event.target.checked;

        try {
            this.props.onChange()
        } catch (e) {

        }
    }

    render() {
        const {field, config,formData} = this.props;
        const id = field.id || field.name;
        let title = field.title;

        if(title.substr(-1) == "*"){
            title = title.slice(0, -1)
        }
        if (field.required) {
            title = <span>{title} <span className='pubhub-smartsheet-form-required'>*</span></span>
        }

        let helpText = field.helpText || "";

        if(window["marked"]){
            helpText = window["marked"].parse(helpText)
        }
        const safeHelpText = DOMPurify.sanitize(helpText, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
        return (
            <div className="row pubhub-smartsheet-form-element pubhub-smartsheet-checkbox" key={id}>

                <div className="pubhub-smartsheet-element">
                    <input className="form-control"
                           aria-describedby={ + 'passwordHelpBlock'}
                           id={id}
                           checked={formData[field.name]}
                           onChange={this.handleChange}
                           type="checkbox"
                    >
                    </input>
                    <label htmlFor={id} className="">{title}</label>
                    <small id={id + 'passwordHelpBlock'} className="form-text text-muted">{safeHelpText}</small>
                </div>
            </div>

        )
    }
}
